<template>
   <header :class="{ 'pb-3': true, 'position-fixed': fixed }">
      <b-row>
         <b-col class="header-main-menu d-flex" xl="9" md="12" sm="12" v-if="!user_roles.includes(34)">
            <b-button v-if="create_action" v-b-tooltip.hover :title="create_tooltip" @click="createOrder" variant="outline-primary">
               <span class="icon-plus"></span>
            </b-button>

            <template v-if="copy_action || remove_action">
               <b-button
                  v-if="!is_archived"
                  v-b-tooltip.hover
                  title="Save"
                  class="btn-save"
                  variant="outline-primary"
                  @click="$root.$emit('header:save')"
               >
                  <span class="icon-floppy"></span>
               </b-button>

               <b-button
                  v-if="['order.edit'].includes($route.name)"
                  v-b-tooltip.hover
                  title="Check"
                  @click="$root.$emit('header:check')"
                  variant="outline-primary"
               >
                  Check
               </b-button>

               <b-button v-if="copy_action" v-b-tooltip.hover title="Copy" @click="$root.$emit('header:copy')" variant="outline-primary">
                  <span class="icon-docs"></span>
               </b-button>

               <b-button
                  v-if="!user_roles.includes(38) && !is_archived && remove_action"
                  v-b-tooltip.hover
                  title="Move to archive"
                  @click="$root.$emit('header:remove')"
                  variant="danger"
               >
                  Move to archive
               </b-button>

               <b-button
                  v-if="!user_roles.includes(38) && is_archived && remove_action"
                  v-b-tooltip.hover
                  title="Restore from archive"
                  @click="$root.$emit('header:restore')"
                  variant="success"
               >
                  Restore from archive
               </b-button>

               <b-dropdown
                  v-if="['order.edit'].includes($route.name) && !user_roles.includes(38)"
                  id="reports-dropdown"
                  text="Reports"
                  variant="outline-primary"
               >
                  <b-dropdown id="invoice-breakdown" dropright text="Invoice breakdown" variant="outline-none">
                     <b-dropdown-item @click="$root.$emit('header::create-report', 'INVBRKDWN', 'pdf')">PDF</b-dropdown-item>
                     <b-dropdown-item @click="$root.$emit('header::create-report', 'INVBRKDWN', 'docx')">DOCX</b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown id="itinerary-for-client" dropright text="Itinerary for client" variant="outline-none">
                     <b-dropdown-item @click="$root.$emit('header::create-report', 'ITINERCLIEN', 'pdf')">PDF</b-dropdown-item>
                     <b-dropdown-item @click="$root.$emit('header::create-report', 'ITINERCLIEN', 'docx')">DOCX</b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown-item
                     @click="$root.$emit('header::create-report', 'ITINERCLIEN', 'pdf', 'view')"
                     class="pl-1"
                     link-class="pl-2 text-uppercase"
                  >
                     Itinerary for Agent
                  </b-dropdown-item>
                  <b-dropdown-item @click="$root.$emit('header::supplier-reminders')" class="pl-1" link-class="pl-2 text-uppercase">
                     <b-icon icon="chat-dots" /> Supplier Reminders
                  </b-dropdown-item>
                  <b-dropdown-item @click="$root.$emit('header::get-templates')" class="pl-1" link-class="pl-2 text-uppercase">
                     <b-icon icon="chat-dots" /> Templates
                  </b-dropdown-item>
               </b-dropdown>
            </template>

            <template v-for="item in routes">
               <b-button
                  :key="item.name"
                  :title="item.value"
                  :to="{ name: item.name }"
                  v-b-tooltip.hover
                  :variant="$route.name === item.name ? 'primary' : 'outline-primary'"
               >
                  {{ item.value }}
               </b-button>
            </template>
         </b-col>
         <b-col xl="3" md="12" sm="12" class="header-search d-flex justify-content-end">
            <b-button :to="{ name: 'mobile.home' }" class="p-0 mr-2" variant="outline-primary">
               <span class="icon-mobile"></span>
            </b-button>

            <search-input class="mr-2" placeholder="Enter Lead Guest or Our Ref" />

            <!--
            <b-dropdown right variant="outline-primary" class="mr-2">
               <template #button-content>
                  <span class="icon-cog"></span>
               </template>

               <b-dropdown-item :to="{ name: 'settings:activities' }">
                  Activity options
               </b-dropdown-item>
               <b-dropdown-item :to="{ name: 'settings:suppliers' }">
                  Activity suppliers
               </b-dropdown-item>
            </b-dropdown>
            -->

            <logout>
               <span v-if="text_before_logout && is_archived" class="pr-3 text-danger">
                  {{ text_before_logout }}
               </span>
            </logout>
         </b-col>
      </b-row>
   </header>
</template>

<script>
import { mapState } from 'vuex';
import { BookingsApi } from '@/api/BookingsApi';
import { SuppliersApi } from '@/api/SuppliersApi';
import { ActivitiesApi } from '@/api/ActivitiesApi';

export default {
   name: 'Header',
   props: {
      is_archived: {
         type: Boolean,
         default: false,
      },
      create_action: {
         type: Boolean,
         default: true,
      },
      copy_action: {
         type: Boolean,
         default: false,
      },
      remove_action: {
         type: Boolean,
         default: false,
      },
      fixed: {
         type: Boolean,
         default: false,
      },
      text_before_logout: {
         type: String,
         default: undefined,
      },
   },
   computed: {
      ...mapState({
         beforeunload: s => s.beforeunload,
         loadBeforeunload: s => s.loadBeforeunload,
         user_roles: s => s.users.roles,
      }),
   },
   components: {
      SearchInput: () => import('@/components/SearchInput.vue'),
   },
   data() {
      return {
         routes: [
            { name: 'reports:activities', value: 'Activities' },
            { name: 'reports:accommodations', value: 'Accommodation' },
            { name: 'reports:transfers', value: 'Transfers' },
            { name: 'reports:tasks', value: 'Tasks' },
         ],
         isDropdown2Visible: false,
         create_tooltip: 'Create',
      };
   },
   mounted() {
      this.$root.$on('bv::dropdown::show', bvEvent => {
         if (['invoice-breakdown', 'itinerary-for-client'].includes(bvEvent.componentId)) {
            this.isDropdown2Visible = true;
         }
      });

      this.$root.$on('bv::dropdown::hide', bvEvent => {
         if (['invoice-breakdown', 'itinerary-for-client'].includes(bvEvent.componentId)) {
            this.isDropdown2Visible = false;
         }
         if (this.isDropdown2Visible) {
            bvEvent.preventDefault();
         }
      });

      if (this.$route.name.includes('settings:supplier')) {
         this.create_tooltip = 'Create New Supplier';
      } else if (this.$route.name.includes('settings:activit')) {
         this.create_tooltip = 'Create New Activity';
      } else {
         this.create_tooltip = 'Create New Group';
      }

      if (!this.user_roles.includes(38)) {
         //this.routes.push({ name: 'calendar', value: 'Calendar' });
         this.routes.push({ name: 'orders', value: 'Order list' });
      }

      if (!this.user_roles.includes(38)) {
         this.routes.push({ name: 'settings:activities', value: 'Activity options' });
         this.routes.push({ name: 'settings:suppliers', value: 'Activity suppliers' });
      }
   },
   methods: {
      createOrder() {
         if (this.$route.name.includes('.edit')) {
            if (this.beforeunload !== this.loadBeforeunload) {
               if (!window.confirm('You have unsaved changes. Are you sure you want to leave this page?')) {
                  return;
               }
            }
         }

         if (this.$route.name.includes('settings:supplier')) {
            this.$store.commit('showLoading');
            SuppliersApi.create()
               .then(({ id }) => {
                  this.$router.push({ name: 'settings:supplier.edit', params: { id } });
               })
               .finally(() => {
                  this.$store.commit('hideLoading');
               });

            return;
         }

         if (this.$route.name.includes('settings:activit')) {
            this.$store.commit('showLoading');
            ActivitiesApi.create()
               .then(({ id }) => {
                  this.$router.push({ name: 'settings:activity.edit', params: { id } });
               })
               .finally(() => {
                  this.$store.commit('hideLoading');
               });

            return;
         }

         this.$store.commit('showLoading');
         BookingsApi.createOrder()
            .then(({ id }) => {
               this.$router.push({ name: 'order.edit', params: { id } });
            })
            .finally(() => {
               this.$store.commit('hideLoading');
            });
      },
   },
};
</script>

<style lang="scss">
header {
   .btn {
      text-transform: uppercase;
   }
}
</style>
